import { useEffect } from "react";

const SITE = "Sėdynės.lt";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, image, jsonLd, noindex = false }) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return;
    const full = title.includes(SITE) ? title : `${title} | ${SITE}`;
    document.title = full;
    const url = window.location.origin + window.location.pathname + window.location.search;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", jsonLd ? "product" : "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);
    let s = document.getElementById("seo-jsonld");
    if (ld) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "seo-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = ld;
    } else if (s) s.remove();
  }, [title, description, image, ld, noindex]); // eslint-disable-line react-hooks/exhaustive-deps
};
